const timerStates = require('./timerStates')
const actionList = {
  resume: timerStates.STARTED,
  pause: timerStates.PAUSED,
  stop: timerStates.STOPPED
}
const USERTASK_SERVICE = '/api/usertask'

const _resume = userTaskService => async userTaskId =>
  _updateStatus(userTaskService, userTaskId, 'resume')

const _pause = userTaskService => async userTaskId =>
  _updateStatus(userTaskService, userTaskId, 'pause')

const _stop = userTaskService => async userTaskId =>
  _updateStatus(userTaskService, userTaskId, 'stop')

const _updateStatus = (userTaskService, userTaskId, action) =>
  userTaskService
    .patch(userTaskId, { status: actionList[action] }, _buildParams())
    .catch(() => {
      throw new Error(
        `Could not perform ${action} for userTask with ID ${userTaskId}`
      )
    })

// For updating anything else than the status
const _update = userTaskService => async (userTaskId, updateObj) =>
  userTaskService.patch(userTaskId, updateObj)

const _createTimer = userTaskService => async userTask =>
  userTaskService.create(userTask, _buildParams())

const _createTimerFromTimeCard = userTaskService => async (timeCard, userId) =>
  userTaskService.create(
    {
      userId,
      projectId: timeCard.projectId,
      activityId: timeCard.activityId,
      taskId: timeCard.taskId,
      timeCardId: timeCard.id,
      status: timerStates.STARTED
    },
    _buildParams()
  )

const _removeTimer = userTaskService => async (userTaskId, teamParams) =>
  userTaskService.remove(userTaskId, teamParams)

const _getActiveTimerForUser = userTaskService => async teamParams =>
  userTaskService.find({
    ...teamParams,
    query: {
      userId: teamParams.userId,
      status: { $in: ['started', 'paused'] },
      $limit: 1,
      $client: {
        subObjects: {
          timecard: [
            'id',
            'timeTaken',
            'createdOn',
            'projectId',
            'activityId',
            'taskId'
          ],
          task: ['id', 'timeSpent']
        }
      }
    }
  })

const _getNewDate = () => new Date()

const _buildParams = (dateProviderFn = _getNewDate) => ({
  query: {
    $client: {
      activeDate: _getMidnight(dateProviderFn)
    }
  }
})

// we set it to the midnight to unify the data because we do not care about the specific time
const _getMidnight = dateProviderFn => {
  const date = dateProviderFn()
  return new Date(date.setHours(0, 0, 0, 0))
}

const buildTimerEvents = app => {
  const userTaskService = app.service(USERTASK_SERVICE)
  return {
    resume: _resume(userTaskService),
    pause: _pause(userTaskService),
    stop: _stop(userTaskService),
    updateStatus: _updateStatus,
    update: _update(userTaskService),
    createTimer: _createTimer(userTaskService),
    createTimerFromTimeCard: _createTimerFromTimeCard(userTaskService),
    removeTimer: _removeTimer(userTaskService),
    getActiveTimerForUser: _getActiveTimerForUser(userTaskService),
    actionList,
    // this function is exported for testing purposes and should not be used outside of this module
    _buildParams
  }
}

module.exports = { buildTimerEvents }
